export default __webpack_public_path__ + "img/play.e3d16006.svg";